import gql from "graphql-tag";
const SESSION_ACTIVITY = gql`
	mutation {
		sessionActivity
	}
`;
const REGISTER_MY_CONTACT = gql`
	mutation ($input: ContactProfileInput!) {
		editMe(input: $input) {
			id
			verificationStatusId
			photoId
		}
	}
`;
const EDIT_MY_CONTACT = gql`
	mutation ($input: ContactProfileInput!) {
		editMe(input: $input) {
			id
			verificationStatusId
		}
	}
`;
const START_CHAT = gql`
	mutation ($participants: [UUID!]!) {
		startChat(participants: $participants) {
			id
			name
			participants {
				contact {
					id
					name
				}
			}
		}
	}
`;
const SEND_MESSAGE_TO_CONTACT = gql`
	mutation ($contactId: UUID!, $text: String!) {
		sendMessageToContact(contactId: $contactId, text: $text)
	}
`;
const ADD_MESSAGE_TO_CHAT = gql`
	mutation ($input: MessageInput!) {
		addMessageToChat(input: $input) {
			id
			text
			createdOn
			isSeen
			contactId
			replyToMessage {
				id
				text
				createdOn
				isSeen
				contactId
				files {
					id
					name
					typeId
					extension
					contentType
					duration
				}
			}
			files {
				id
				name
				typeId
				extension
				contentType
				duration
			}
		}
	}
`;
const EDIT_MESSAGE = gql`
	mutation ($input: EditMessageInput!) {
		editMessage(input: $input) {
			id
			text
			createdOn
			isSeen
			contactId
			replyToMessage {
				id
				text
				createdOn
				isSeen
				contactId
				files {
					id
					name
					typeId
					extension
					contentType
					duration
				}
			}
			files {
				id
				name
				typeId
				extension
				contentType
				duration
			}
		}
	}
`;
const SET_OFFLINE = gql`
	mutation {
		setOffline
	}
`;
const SET_VIEWED_FROM_DATE = gql`
	mutation ($fromDate: DateTime, $chat: BaseIdInput!) {
		setViewedFromDate(fromDate: $fromDate, chat: $chat)
	}
`;
const ADD_CONTACT_COMMENT = gql`
	mutation ($input: ContactCommentInput!) {
		addContactComment(input: $input) {
			id
		}
	}
`;
const ADD_CONTACT_COMMENT_REACTION = gql`
	mutation ($input: CommentReactionInput!) {
		addContactCommentReaction(input: $input) {
			count
			isLiked
		}
	}
`;
const DELETE_PUBLIC_ARTICLE = gql`
	mutation ($code: String!) {
		deletePublicArticle(code: $code)
	}
`;
const DELETE_HTML_TEMPLATE = gql`
	mutation ($code: String!) {
		deleteHtmlTemplate(code: $code)
	}
`;
const ADD_OR_EDIT_PUBLIC_ARTICLE = gql`
	mutation ($inputs: [PublicArticleInput!]!) {
		result: addOrEditPublicArticle(inputs: $inputs)
	}
`;
const EDIT_SYSTEM_SETTINGS = gql`
	mutation ($inputs: [BaseEntityWithValueInput!]!) {
		systemSettings(inputs: $inputs)
	}
`;
const CAN_USE_EMAIL = gql`
	mutation ($email: String!) {
		canUseEmail(email: $email)
	}
`;
const SEND_EMAIL = gql`
	mutation ($to: String!, $subject: String!, $body: String!) {
		sendEmail(to: $to, subject: $subject, body: $body) {
			statusCode
			errorMessage
		}
	}
`;
const CHANGE_USER_ROLES = gql`
	mutation ($userId: UUID!, $roles: [BaseLookupEntityInput!]!) {
		changeUserRoles(userId: $userId, roles: $roles)
	}
`;
const ADD_OR_EDIT_ROLE = gql`
	mutation ($input: RoleInput!) {
		addOrEditRole(input: $input) {
			id
		}
	}
`;
const SET_LDAP_GROUP_SETTINGS = gql`
	mutation ($value: LdapGroupSettingsInput!) {
		setLdapGroupSettings(value: $value)
	}
`;
const SYNC_LDAP_GROUPS = gql`
	mutation {
		syncLdapGroups {
			isSuccess
			error
			created
			updated
			checked
		}
	}
`;
const SYNC_LDAP_GROUP = gql`
	mutation ($roleId: UUID!) {
		syncLdapGroup(roleId: $roleId) {
			isSuccess
			result
			error
		}
	}
`;
const ADD_OR_EDIT_POLICY = gql`
	mutation ($input: PolicyInput!) {
		addOrEditPolicy(input: $input) {
			id
		}
	}
`;
const CHANGE_CONTACT_ISACTIVE = gql`
	mutation ($contactId: UUID!, $isActive: Boolean!) {
		changeContactIsActive(contactId: $contactId, isActive: $isActive)
	}
`;
const CHANGE_MAIN_PHOTO = gql`
	mutation ($fileId: UUID!) {
		changeMainPhoto(fileId: $fileId)
	}
`;
const SET_USER_SETTING = gql`
	mutation ($key: String!, $data: String!) {
		settings {
			user {
				setting_value: setting(input: { key: $key, data: $data })
			}
		}
	}
`;
const SET_USER_SETTINGS = gql`
	mutation ($inputs: [UserSettingInput!]!) {
		settings {
			user {
				setting_value: settings(inputs: $inputs) {
					key
					data
				}
			}
		}
	}
`;
const RESET_USER_SETTING = gql`
	mutation ($key: String!) {
		settings {
			user {
				setting_value: resetSetting(key: $key)
			}
		}
	}
`;
const RESET_USER_SETTINGS = gql`
	mutation ($keys: [String!]!) {
		settings {
			user {
				setting_value: resetSettings(keys: $keys) {
					key
					data
				}
			}
		}
	}
`;
const ADMIN_SET_USER_SETTING = gql`
	mutation (
		$key: String!
		$data: String!
		$isDefault: Boolean!
		$replace: Boolean!
		$contactId: UUID
	) {
		settings {
			admin {
				setting_value: setting(
					contactId: $contactId
					input: {
						key: $key
						data: $data
						isDefault: $isDefault
						replace: $replace
					}
				) {
					key
					data
					isDefault
				}
			}
		}
	}
`;
const ADMIN_SET_USER_SETTINGS = gql`
	mutation ($contactId: UUID, $inputs: [AdminUserSettingInput!]!) {
		settings {
			admin {
				setting_value: settings(
					contactId: $contactId
					inputs: $inputs
				) {
					key
					data
					isDefault
				}
			}
		}
	}
`;
const RESET_SETTING_FOR = gql`
	mutation ($contactId: UUID!, $key: String!) {
		settings {
			admin {
				setting_value: resetSettingFor(
					contactId: $contactId
					key: $key
				) {
					key
					data
					isDefault
				}
			}
		}
	}
`;
const RESET_SETTINGS_FOR = gql`
	mutation ($contactId: UUID!, $keys: [String!]!) {
		settings {
			admin {
				setting_value: resetSettingsFor(
					contactId: $contactId
					keys: $keys
				) {
					key
					data
					isDefault
				}
			}
		}
	}
`;
const DELETE_SETTING = gql`
	mutation ($key: String!) {
		settings {
			admin {
				setting_value: deleteSetting(key: $key)
			}
		}
	}
`;
const DELETE_SETTINGS = gql`
	mutation ($keys: [String!]!) {
		settings {
			admin {
				setting_value: deleteSettings(keys: $keys)
			}
		}
	}
`;
export {
  ADD_CONTACT_COMMENT,
  ADD_CONTACT_COMMENT_REACTION,
  ADD_MESSAGE_TO_CHAT,
  ADD_OR_EDIT_POLICY,
  ADD_OR_EDIT_PUBLIC_ARTICLE,
  ADD_OR_EDIT_ROLE,
  ADMIN_SET_USER_SETTING,
  ADMIN_SET_USER_SETTINGS,
  CAN_USE_EMAIL,
  CHANGE_CONTACT_ISACTIVE,
  CHANGE_MAIN_PHOTO,
  CHANGE_USER_ROLES,
  DELETE_HTML_TEMPLATE,
  DELETE_PUBLIC_ARTICLE,
  DELETE_SETTING,
  DELETE_SETTINGS,
  EDIT_MESSAGE,
  EDIT_MY_CONTACT,
  EDIT_SYSTEM_SETTINGS,
  REGISTER_MY_CONTACT,
  RESET_SETTINGS_FOR,
  RESET_SETTING_FOR,
  RESET_USER_SETTING,
  RESET_USER_SETTINGS,
  SEND_EMAIL,
  SEND_MESSAGE_TO_CONTACT,
  SESSION_ACTIVITY,
  SET_LDAP_GROUP_SETTINGS,
  SET_OFFLINE,
  SET_USER_SETTING,
  SET_USER_SETTINGS,
  SET_VIEWED_FROM_DATE,
  START_CHAT,
  SYNC_LDAP_GROUP,
  SYNC_LDAP_GROUPS
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
